module.exports = __webpack_public_path__ + "assets/img/10.eed911d9.png";